var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated revealUp"},[_c('div',{staticClass:"white-wrapper",staticStyle:{"zoom":"0.9"}},[_c('div',{staticClass:"section-title mb-4"},[_vm._v("Monthly Food Cost")]),_vm._v(" "),_c('div',{staticClass:"mt-3 mb-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 align-self-center mb-2"},[_c('div',{staticClass:"dropdown-curve-container"},[_c('label',{class:_vm.cogsPayload['cinema_id'] ? 'shift-up' : ''},[_vm._v(_vm._s(_vm.$t("select"))+" "+_vm._s(_vm.$tc("cinema", 1)))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.Cinemas,"searchable":true,"label":"cine_name","track-by":"cine_id","placeholder":""},on:{"select":function($event){return _vm.onSelectCinema($event)},"remove":function($event){return _vm.onRemoveCinema($event)}},model:{value:(_vm.selectedCinema),callback:function ($$v) {_vm.selectedCinema=$$v},expression:"selectedCinema"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col-xl-2 align-self-center mb-2"},[_c('div',{staticClass:"input-material"},[_c('div',{staticClass:"add-datepicker"},[_c('Datepicker',{ref:"programaticOpen",attrs:{"monday-first":true,"type":"date","disabled-dates":_vm.disabledDates},on:{"selected":function($event){return _vm.onChangeDate($event, 'from')}},model:{value:(_vm.cogsPayload['fromDate']),callback:function ($$v) {_vm.$set(_vm.cogsPayload, 'fromDate', $$v)},expression:"cogsPayload['fromDate']"}}),_vm._v(" "),_c('label',{class:_vm.cogsPayload['fromDate'] ? 'active' : ''},[_vm._v("\n                "+_vm._s(_vm.$t("fromdate"))+"\n              ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col-xl-2 align-self-center mb-2"},[_c('div',{staticClass:"input-material"},[_c('div',{staticClass:"add-datepicker"},[_c('Datepicker',{ref:"programaticOpen",attrs:{"monday-first":true,"type":"date","disabled-dates":_vm.disabledDates},model:{value:(_vm.cogsPayload['toDate']),callback:function ($$v) {_vm.$set(_vm.cogsPayload, 'toDate', $$v)},expression:"cogsPayload['toDate']"}}),_vm._v(" "),_c('label',{class:_vm.cogsPayload['toDate'] ? 'active' : ''},[_vm._v("\n                "+_vm._s(_vm.$t("todate"))+"\n              ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 align-self-center mb-2"},[_c('div',{staticClass:"dropdown-curve-container"},[_c('label',{class:_vm.cogsPayload['rmc_id'] ? 'shift-up' : ''},[_vm._v(_vm._s(_vm.$t("select"))+" "+_vm._s(_vm.$tc("category", 1)))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.rawMaterialCategories,"searchable":true,"label":"rmc_category","track-by":"rmc_id","placeholder":""},on:{"select":function($event){return _vm.onSelectCategoey($event)},"remove":function($event){return _vm.onRemoveCategory($event)}},model:{value:(_vm.selectedCategory),callback:function ($$v) {_vm.selectedCategory=$$v},expression:"selectedCategory"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 align-self-center mb-2"},[_c('div',{staticClass:"dropdown-curve-container"},[_c('label',{class:_vm.cogsPayload['sm_id'] ? 'shift-up' : ''},[_vm._v(_vm._s(_vm.$t("select"))+" "+_vm._s(_vm.$tc("store", 1)))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.storeList,"searchable":true,"label":"sm_store_name","track-by":"sm_id","placeholder":""},on:{"select":function($event){return _vm.onSelectLocation($event, 'select')},"remove":function($event){return _vm.onSelectLocation($event, 'remove')}},model:{value:(_vm.selectedStore),callback:function ($$v) {_vm.selectedStore=$$v},expression:"selectedStore"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col-xl-2 align-self-center mb-2"},[_c('button',{staticClass:"btn btn-primary w-100",on:{"click":_vm.fetchFoodCostReport}},[_vm._v("\n            "+_vm._s(_vm.$tc("getReport"))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"d-flex align-item-center justify-content-center",staticStyle:{"gap":"15px"}},[_c('b-form-input',{directives:[{name:"debounce",rawName:"v-debounce:500",value:(_vm.resetList),expression:"resetList",arg:"500"}],attrs:{"placeholder":"Search..."},model:{value:(_vm.cogsPayload.searchValue),callback:function ($$v) {_vm.$set(_vm.cogsPayload, "searchValue", $$v)},expression:"cogsPayload.searchValue"}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex"}),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[(_vm.getCogsRecords.length > 0)?_c('div',{staticClass:"align-self-center mb-1 d-flex justify-content-end align-items-center"},[_c('div',[_vm._v(_vm._s(_vm.$t("download"))+" as:")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","download":"","title":"Download as PDF"},on:{"click":function($event){return _vm.fetchFoodCostReport("PDF")}}},[_c('img',{attrs:{"src":require("@/assets/img/icons/pdf-icon.svg"),"height":"25","width":"25"}})]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","title":"Download as Excel"},on:{"click":function($event){return _vm.fetchFoodCostReport("excel")}}},[_c('img',{staticClass:"mx-2",attrs:{"src":require("@/assets/img/icons/excel.svg"),"height":"25","width":"25"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mx-2 text-left d-flex justify-content-end"},[_c('b-dropdown',{attrs:{"name":"listview","id":"listview","variant":"outline-blue"},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_vm._v("\n                "+_vm._s(_vm.$t("viewing"))+" \n                "),_c('strong',[_vm._v(_vm._s(_vm.selectedvalue))]),_vm._v("\n                 "+_vm._s(_vm.$t("of"))+" \n                "),_c('strong',[_vm._v(_vm._s(_vm.rows))])]},proxy:true}])},[_vm._v(" "),_vm._l((_vm.viewingnumbers),function(list,listIndex){return _c('b-dropdown-item',{key:listIndex,attrs:{"href":"#"},on:{"click":function($event){return _vm.onDropDownChangeValue(list.name)}}},[_vm._v(_vm._s(list.name))])})],2)],1)])])]),_vm._v(" "),_c('div',{staticClass:"swc-report",staticStyle:{"overflow-x":"scroll"}},[_c('table',{staticClass:"swc-report-table",staticStyle:{"width":"auto"},attrs:{"border":"1"}},[_c('thead',{staticClass:"bg-lightgrey",staticStyle:{"white-space":"nowrap"}},[_c('tr',[_c('th',{staticClass:"wd280 sticky-cell"},[_vm._v(_vm._s(_vm.$tc("rawmaterials")))]),_vm._v(" "),_c('th',{staticClass:"sticky-cell"},[_vm._v("UOM")]),_vm._v(" "),_c('th',{staticClass:"sticky-cell"},[_vm._v(_vm._s(_vm.$t("rate")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("openingStock")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("purchase")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("property_in")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("property_out")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("wastage")))]),_vm._v(" "),_c('th',[_vm._v("Closing")]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("Actual Consumption")]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("Ideal Consumption")]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("Variance")]),_vm._v(" "),_c('th',[_vm._v("Variance %")])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(!_vm.getCogsGroupedRecords)?_c('tbody',[_c('tr',{attrs:{"rowspan":"13"}},[_c('td',{attrs:{"colspan":"13"}},[_c('NoRecords')],1)])]):_c('tbody',{staticClass:"sph-report"},[_vm._l((Object.keys(_vm.getCogsGroupedRecords)),function(RawMaterialCategory,RawMaterialCategoryIndex){return [_c('tr',{key:RawMaterialCategoryIndex},[_c('td',{staticClass:"font-weight-bold text-left concession_blue",staticStyle:{"border-right-color":"transparent"},attrs:{"colspan":"26"}},[_vm._v("\n                "+_vm._s(RawMaterialCategory)+"\n              ")])]),_vm._v(" "),_vm._l((_vm.getCogsGroupedRecords[RawMaterialCategory]),function(singleRawItem,singleRawItemKey){return _c('tr',{key:singleRawItemKey + RawMaterialCategoryIndex,staticClass:"text-right"},[_c('td',{staticClass:"text-left sticky-cell"},[_vm._v("\n                "+_vm._s(singleRawItem.rm_name)+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-left sticky-cell"},[_vm._v("\n                "+_vm._s(singleRawItem.uom_name)+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"sticky-cell"},[_vm._v("\n                "+_vm._s(_vm.currFormat(singleRawItem.purchase_rate))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(parseFloat(singleRawItem.opening_stock || 0).toFixed(5))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(parseFloat(singleRawItem.purchase_stock || 0).toFixed(5))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(parseFloat(singleRawItem.property_in || 0).toFixed(5))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(parseFloat(singleRawItem.property_out || 0).toFixed(5))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(parseFloat(singleRawItem.wastage || 0).toFixed(5)))]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(parseFloat(singleRawItem.system_stock || 0).toFixed(5))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(parseFloat(
                    parseFloat(singleRawItem.standard_consumed || 0) -
                      parseFloat(singleRawItem.variance || 0)
                  ).toFixed(5))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    (parseFloat(singleRawItem.standard_consumed || 0) -
                      parseFloat(singleRawItem.variance || 0)) *
                      parseFloat(singleRawItem.purchase_rate || 0)
                  ))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(parseFloat(singleRawItem.standard_consumed || 0).toFixed(5))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    parseFloat(singleRawItem.standard_consumed || 0) *
                      parseFloat(singleRawItem.purchase_rate || 0)
                  ))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(parseFloat(singleRawItem.variance || 0).toFixed(5))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(parseFloat(
                    parseFloat(singleRawItem.variance) *
                      parseFloat(singleRawItem.purchase_rate || 0)
                  ).toFixed(5))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(!isFinite(
                    parseFloat(
                      (Math.abs(parseFloat(singleRawItem.variance || 0)) /
                        Number(singleRawItem.standard_consumed || 0)) *
                        100
                    ).toFixed(2)
                  ) ||
                  isNaN(
                    parseFloat(
                      (Math.abs(parseFloat(singleRawItem.variance || 0)) /
                        Number(singleRawItem.standard_consumed || 0)) *
                        100
                    ).toFixed(2)
                  )
                    ? "-"
                    : parseFloat(
                        (Math.abs(parseFloat(singleRawItem.variance || 0)) /
                          Number(singleRawItem.standard_consumed || 0)) *
                          100
                      ).toFixed(2))+"\n              ")])])}),_vm._v(" "),_c('tr',{staticClass:"font-weight-bold",staticStyle:{"background-color":"#e8e8e8"}},[_c('td',{staticClass:"text-left sticky-cell"},[_vm._v("Total")]),_vm._v(" "),_c('td',{staticClass:"text-right sticky-cell"},[_vm._v("-")]),_vm._v(" "),_c('td',{staticClass:"text-right sticky-cell"},[_vm._v("\n                "+_vm._s(_vm.getCogsGroupedRecords[RawMaterialCategory].reduce(
                    function (acc, ref) {
                      var purchase_rate = ref.purchase_rate;

                      return acc + purchase_rate;
                    },
                    0
                  ).toFixed(4))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.getCogsGroupedRecords[RawMaterialCategory].reduce(
                    function (acc, ref) {
                      var opening_stock = ref.opening_stock;

                      return acc + opening_stock;
                    },
                    0
                  ).toFixed(4))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.getCogsGroupedRecords[RawMaterialCategory].reduce(
                    function (acc, ref) {
                      var purchase_stock = ref.purchase_stock;

                      return acc + purchase_stock;
                    },
                    0
                  ).toFixed(4))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.getCogsGroupedRecords[RawMaterialCategory].reduce(
                    function (acc, ref) {
                      var property_in = ref.property_in;

                      return acc + property_in;
                    },
                    0
                  ).toFixed(4))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.getCogsGroupedRecords[RawMaterialCategory].reduce(
                    function (acc, ref) {
                      var property_out = ref.property_out;

                      return acc + property_out;
                    },
                    0
                  ).toFixed(4))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.getCogsGroupedRecords[RawMaterialCategory].reduce(
                    function (acc, ref) {
                      var wastage = ref.wastage;

                      return acc + wastage;
                    },
                    0
                  ).toFixed(4))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.getCogsGroupedRecords[RawMaterialCategory].reduce(
                    function (acc, ref) {
                      var system_stock = ref.system_stock;

                      return acc + system_stock;
                    },
                    0
                  ).toFixed(4))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.getCogsGroupedRecords[RawMaterialCategory].reduce(
                    function (acc, ref) {
                      var standard_consumed = ref.standard_consumed;
                      var variance = ref.variance;

                      return acc + standard_consumed - variance;
                    },
                    0
                  ).toFixed(4))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.getCogsGroupedRecords[RawMaterialCategory].reduce(
                    function (acc, ref) {
                      var standard_consumed = ref.standard_consumed;
                      var variance = ref.variance;
                      var purchase_rate = ref.purchase_rate;

                      return (
                        acc + (standard_consumed - variance) * purchase_rate
                      );
                    },
                    0
                  ).toFixed(4))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.getCogsGroupedRecords[RawMaterialCategory].reduce(
                    function (acc, ref) {
                      var standard_consumed = ref.standard_consumed;

                      return acc + standard_consumed;
                    },
                    0
                  ).toFixed(4))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.getCogsGroupedRecords[RawMaterialCategory].reduce(
                    function (acc, ref) {
                      var standard_consumed = ref.standard_consumed;
                      var purchase_rate = ref.purchase_rate;

                      return (
                        acc +
                        parseFloat(standard_consumed || 0) *
                          parseFloat(purchase_rate || 0)
                      );
                    },
                    0
                  ).toFixed(4))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.getCogsGroupedRecords[RawMaterialCategory].reduce(
                    function (acc, ref) {
                      var variance = ref.variance;

                      return acc + variance;
                    },
                    0
                  ).toFixed(4))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.getCogsGroupedRecords[RawMaterialCategory].reduce(
                    function (acc, ref) {
                      var variance_value = ref.variance_value;

                      return acc + variance_value;
                    },
                    0
                  ).toFixed(4))+"\n              ")]),_vm._v(" "),_c('td')])]}),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('td',{staticClass:"text-left font-weight-bold sticky-cell"},[_vm._v("\n              Grand Total\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right sticky-cell"},[_vm._v("-")]),_vm._v(" "),_c('td',{staticClass:"text-right sticky-cell"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (total, ref) {
                                          var purchase_rate = ref.purchase_rate;

                                          return total + purchase_rate;
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (total, ref) {
                                          var opening_stock = ref.opening_stock;

                                          return total + opening_stock;
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (total, ref) {
                                          var purchase_stock = ref.purchase_stock;

                                          return total + purchase_stock;
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (total, ref) {
                                          var property_in = ref.property_in;

                                          return total + property_in;
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (total, ref) {
                                          var property_out = ref.property_out;

                                          return total + property_out;
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (total, ref) {
                                          var wastage = ref.wastage;

                                          return total + wastage;
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (total, ref) {
                                          var system_stock = ref.system_stock;

                                          return total + system_stock;
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (total, ref) {
                                            var standard_consumed = ref.standard_consumed;
                                            var variance = ref.variance;

                                            return total + standard_consumed - variance;
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (
                          total,
                          ref
                        ) {
                                            var standard_consumed = ref.standard_consumed;
                                            var variance = ref.variance;
                                            var purchase_rate = ref.purchase_rate;

                                            return total +
                          (standard_consumed - variance) * purchase_rate;
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (total, ref) {
                                            var standard_consumed = ref.standard_consumed;

                                            return total + standard_consumed;
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (total, ref) {
                                            var standard_consumed = ref.standard_consumed;
                                            var purchase_rate = ref.purchase_rate;

                                            return total +
                          parseFloat(standard_consumed || 0) *
                            parseFloat(purchase_rate || 0);
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (total, ref) {
                                          var variance = ref.variance;

                                          return total + variance;
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (total, ref) {
                                            var purchase_rate = ref.purchase_rate;
                                            var variance = ref.variance;

                                            return total +
                          parseFloat(variance || 0) *
                            parseFloat(purchase_rate || 0);
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td')])],2)])]),_vm._v(" "),_c('div',{staticClass:"mt-5"},[(_vm.getCogsGroupedRecords)?_c('table',{staticClass:"swc-report-table",staticStyle:{"width":"auto"},attrs:{"border":"1"}},[_c('tbody',{staticClass:"sph-report"},[_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v("FOOD COST (ACTUAL)")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (
                          total,
                          ref
                        ) {
                                            var standard_consumed = ref.standard_consumed;
                                            var variance = ref.variance;
                                            var purchase_rate = ref.purchase_rate;

                                            return total +
                          (standard_consumed - variance) * purchase_rate;
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(parseFloat(_vm.fnb_total_amount || 0) > 0
                  ? parseFloat(
                      (parseFloat(
                        Object.values(_vm.getCogsGroupedRecords).reduce(
                          function (acc, category) { return acc +
                            category.reduce(
                              function (
                                total,
                                ref
                              ) {
                                                  var standard_consumed = ref.standard_consumed;
                                                  var variance = ref.variance;
                                                  var purchase_rate = ref.purchase_rate;

                                                  return total +
                                (standard_consumed - variance) *
                                  purchase_rate;
                                              },
                              0
                            ); },
                          0
                        )
                      ) /
                        parseFloat(_vm.fnb_total_amount || 0)) *
                        100
                    ).toFixed(2)
                  : "-")+"\n            ")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v("FOOD COST (IDEAL)")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(Object.values(_vm.getCogsGroupedRecords)
                  .reduce(
                    function (acc, category) { return acc +
                      category.reduce(
                        function (total, ref) {
                                            var standard_consumed = ref.standard_consumed;
                                            var purchase_rate = ref.purchase_rate;

                                            return total +
                          parseFloat(standard_consumed || 0) *
                            parseFloat(purchase_rate || 0);
                                        },
                        0
                      ); },
                    0
                  )
                  .toFixed(4))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(parseFloat(_vm.fnb_total_amount || 0) > 0
                  ? parseFloat(
                      (parseFloat(
                        Object.values(_vm.getCogsGroupedRecords).reduce(
                          function (acc, category) { return acc +
                            category.reduce(
                              function (total, ref) {
                                                  var standard_consumed = ref.standard_consumed;
                                                  var purchase_rate = ref.purchase_rate;

                                                  return total +
                                parseFloat(standard_consumed || 0) *
                                  parseFloat(purchase_rate || 0);
                                              },
                              0
                            ); },
                          0
                        )
                      ) /
                        parseFloat(_vm.fnb_total_amount || 0)) *
                        100
                    ).toFixed(2)
                  : "-")+"\n            ")])]),_vm._v(" "),_vm._m(1)])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"sticky-cell"}),_vm._v(" "),_c('th',{staticClass:"sticky-cell"}),_vm._v(" "),_c('th',{staticClass:"sticky-cell"}),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("QTY")]),_vm._v(" "),_c('th',[_vm._v("Value")]),_vm._v(" "),_c('th',[_vm._v("QTY")]),_vm._v(" "),_c('th',[_vm._v("Value")]),_vm._v(" "),_c('th',[_vm._v("QTY")]),_vm._v(" "),_c('th',[_vm._v("Value")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-left"},[_vm._v("BUDGETED FOOD COST")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ba406b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/ReportsContainer/MonthlyFoodCostReport.vue
// module id = null
// module chunks = 